export default function InviteUserController(
  $scope,
  $filter,
  $rootScope,
  $q,
  $state,
  inviteService,
  RoleService,
  securityGroupsService,
  gettextCatalog,
) {
  'ngInject';

  $scope.successFlag = false;
  $scope.successText = '';
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.sending = false;
  $scope.groupsRequired = false;
  $scope.setAll = {};
  $scope.loading = true;
  $scope.emailEditing = false;
  $scope.emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  $scope.roleModel = {
    data: {},
    count: 0,
  };
  $scope.groupModel = {
    data: {},
    count: 0,
  };
  var currentUser = $rootScope.currentUser;

  //Sorting
  $scope.search = {
    query: {
      role: '',
      group: '',
    },
  };
  $scope.rolePredicate = 'name';
  $scope.groupPredicate = 'name';
  $scope.roleReverse = false;
  $scope.groupReverse = false;
  var orderBy = $filter('orderBy');

  //Sort filteredRolePolicies
  $scope.orderRoles = function (predicate, rev) {
    $scope.rolePredicate = predicate;
    if (rev) {
      $scope.roleReverse = $scope.rolePredicate === predicate ? !$scope.roleReverse : false;
    }

    angular.forEach($scope.filteredRoles, function (role) {
      role[predicate] = role[predicate];
    });
    $scope.filteredRoles = orderBy($scope.filteredRoles, $scope.rolePredicate, $scope.roleReverse);
    $scope.displayRolesByPage();
  };

  //Sort filteredDataPoints
  $scope.orderGroups = function (predicate, rev) {
    $scope.groupPredicate = predicate;
    if (rev)
      $scope.groupReverse = $scope.groupPredicate === predicate ? !$scope.groupReverse : false;

    angular.forEach($scope.filteredGroups, function (group) {
      group[predicate] = group[predicate];
    });
    $scope.filteredGroups = orderBy(
      $scope.filteredGroups,
      $scope.groupPredicate,
      $scope.groupReverse,
    );
    $scope.displayGroupsByPage();
  };

  //Pagination
  $scope.current = {
    roles: {
      page: 1,
    },
    groups: {
      page: 1,
    },
  };
  $scope.itemsPerPage = 8;
  $scope.maxSize = 1;

  //displayDataPointsByPage() is used to set the legnth of paging needed for filteredDataPoints.
  $scope.displayRolesByPage = function () {
    $scope.totalRoles = $scope.filteredRoles.length;
    var begin = ($scope.current.roles.page - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    $scope.rolesByPage = $scope.filteredRoles.slice(begin, end);
  };

  //displayRolePoliciesByPage() is used to set the legnth of paging needed for filteredRolePolicies.
  $scope.displayGroupsByPage = function () {
    $scope.totalGroups = $scope.filteredGroups.length;
    var begin = ($scope.current.groups.page - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    $scope.groupsByPage = $scope.filteredGroups.slice(begin, end);
  };

  //Calls displayDataPointsByPage(), everytime the the user changes the page.
  $scope.rolePageChanged = function () {
    $scope.displayRolesByPage();
    GTM_RoleChanges('newUserRolesPageChanged');
  };

  //Calls displayRolePoliciesByPage(), everytime the the user changes the page.
  $scope.groupPageChanged = function () {
    $scope.displayGroupsByPage();
    GTM_GroupChanges('newUserGroupsPageChanged');
  };

  //applyFilter() searches the dataPoints[] for anything matching the search input.
  $scope.applyRoleFilter = function (initialLoad = false) {
    $scope.filteredRoles = $filter('filter')($scope.roles, {
      name: $scope.search.query.role,
    });
    $scope.orderRoles($scope.rolePredicate, false);
    $scope.displayRolesByPage();

    GTM_RoleChanges(initialLoad ? 'newUserRolesLoaded' : 'newUserRolesFilterChanged');
  };

  //applyPoliciesFilter() searches the rolePolicies[] for anything matching the search input.
  $scope.applyGroupFilter = function (initialLoad = false) {
    $scope.filteredGroups = $filter('filter')($scope.groups, {
      name: $scope.search.query.group,
    });
    $scope.orderGroups($scope.groupPredicate, false);
    $scope.displayGroupsByPage();

    GTM_GroupChanges(initialLoad ? 'newUserGroupsLoaded' : 'newUserGroupsFilterChanged');
  };

  $scope.initial = {
    roles: [],
    groups: [],
  };

  $scope.showGroups = false;

  var init = function () {
    var defer = $q.defer();
    RoleService.getRoles({ assignable: true }).then(
      function onSuccess(response) {
        $scope.roles = response.data.slice();
        $scope.filteredRoles = $scope.roles.slice();
        $scope.applyRoleFilter(true);
        if (!$scope.showGroups) {
          defer.resolve();
        } else {
          return securityGroupsService.getAllSecurityGroups().then(
            function (response) {
              $scope.groups = response.data.data.slice();
              $scope.filteredGroups = $scope.groups.slice();
              $scope.applyGroupFilter(true);
              if ($scope.groups.length == 0 && currentUser.securityMode !== 'Open') {
                //if user is discretionary and doesn't belong to a group (ie. no results when querying for groups), don't let them send an invite
                defer.reject(
                  gettextCatalog.getString(
                    'Cannot invite a user if not belonging to a security group.',
                  ),
                );
              }
              defer.resolve();
            },
            function (error) {
              var errorMsg = gettextCatalog.getString(
                'An error occurred while retrieving group information',
              );
              if (error.data || error.status) {
                if (error.data.message) {
                  errorMsg =
                    error.data.message +
                    ' ' +
                    (error.status.toString() + ' - ' + error.statusText.toString());
                } else {
                  errorMsg +=
                    ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
                }
              } else {
                errorMsg += gettextCatalog.getString('. Please try again later.');
              }
              defer.reject(errorMsg);
            },
          );
        }
      },
      function (error) {
        var errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving role information',
        );
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        defer.reject(errorMsg);
      },
    );

    return defer.promise;
  };

  $scope.user = {
    email: '',
  };

  $scope.isFormValid = function (inviteuserForm) {
    $scope.inviteuserForm.$setSubmitted();

    window.dataLayer.push({
      event: 'newUserSendInvite',
      data: {
        valid: !inviteuserForm.$invalid,
      },
    });

    if (inviteuserForm.$invalid) {
      $scope.loading = false;
      return;
    } else {
      sendInvitation();
    }
  };

  // send invite button
  var sendInvitation = function () {
    if (
      !(
        ($scope.user.email.length > 0 || $scope.user.email.$valid) &&
        $scope.roleModel.count > 0 &&
        (!$scope.groupsRequired || $scope.groupModel.count > 0)
      ) ||
      $scope.sending
    ) {
      return;
    }
    $scope.resetFlags();
    $scope.sending = true;
    var roleIds = [];
    var groupIds = [];
    for (var key in $scope.roleModel.data) {
      roleIds.push(key);
    }
    for (var key in $scope.groupModel.data) {
      groupIds.push(key);
    }
    var data = {
      roles: roleIds,
      groups: groupIds,
    };
    inviteService.postInvite($scope.user.email, data).then(function onSuccess(response) {
      if (response.data.status === 'AlreadyMember') {
        $scope.successText = gettextCatalog.getString(
          'That user is already a member of this Onei3 account.',
        );
      } else if (response.data.status === 'AlreadyInvited') {
        $scope.successText = gettextCatalog.getString('That user already has a pending invite.');
      } else if (response.data.status === 'AutoAccepted') {
        $scope.successText = gettextCatalog.getString(
          'This user has been added, no further action is required on their part.',
        );
      } else {
        $scope.successText = gettextCatalog.getString('Invite sent successfully.');
        $state.go('admin.userinvitehistory', {
          userEmail: $scope.user.email,
        });
      }
      $scope.successFlag = true;
      $scope.sending = false;
    }, handleError);
  };

  //general error handler.
  function handleError(error) {
    var errorMsg = gettextCatalog.getString('An error occurred while sending the invite');
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg =
          error.data.message +
          ' ' +
          (error.status.toString() + ' - ' + error.statusText.toString());
      } else {
        errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
      }
    } else {
      errorMsg += gettextCatalog.getString('. Please try again later.');
    }
    $scope.errorFlag = true;
    $scope.errorText = errorMsg;
    $scope.sending = false;
  }

  $scope.resetFlags = function () {
    $scope.successFlag = false;
    $scope.errorFlag = false;
  };

  $scope.roleSelected = function (role, checkedAll = false) {
    if (role._selected) {
      $scope.roleModel.data[role.id] = role;
      $scope.roleModel.count++;
    } else {
      delete $scope.roleModel.data[role.id];
      $scope.roleModel.count--;
    }
    if (!checkedAll) {
      GTM_RoleChanges(role._selected ? 'newUserRoleSelected' : 'newUserRoleDeselected');
    }
  };

  $scope.groupSelected = function (group, checkedAll = false) {
    if (group._selected) {
      $scope.groupModel.data[group.id] = group;
      $scope.groupModel.count++;
    } else {
      delete $scope.groupModel.data[group.id];
      $scope.groupModel.count--;
    }

    if (!checkedAll) {
      GTM_GroupChanges(group._selected ? 'newUserGroupSelected' : 'newUserGroupDeselected');
    }
  };

  $scope.checkAllRoles = function () {
    for (var i = 0; i < $scope.roles.length; i++) {
      $scope.roles[i]._selected = $scope.setAll.roles;
      $scope.roleSelected($scope.roles[i], true);
    }
    GTM_RoleChanges($scope.setAll.roles ? 'newUserRolesAllSelected' : 'newUserRolesAllDeselected');
  };

  $scope.checkAllGroups = function () {
    for (var i = 0; i < $scope.groups.length; i++) {
      $scope.groups[i]._selected = $scope.setAll.groups;
      $scope.groupSelected($scope.groups[i], true);
    }

    GTM_GroupChanges(
      $scope.setAll.groups ? 'newUserGroupsAllSelected' : 'newUserGroupsAllDeselected',
    );
  };

  function GTM_RoleChanges(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.roles.length,
        totalSelected: $scope.roleModel.count,
        totalFiltered: $scope.filteredRoles.length,
        pageNumber: $scope.current.roles.page,
        sortDirection: $scope.roleReverse ? 'descending' : 'ascending',
      },
    });
  }

  function GTM_GroupChanges(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.groups.length,
        totalSelected: $scope.groupModel.count,
        totalFiltered: $scope.filteredGroups.length,
        pageNumber: $scope.current.groups.page,
        sortDirection: $scope.groupReverse ? 'descending' : 'ascending',
      },
    });
  }

  if (currentUser) {
    if (currentUser.account.securityMode !== 'Open') {
      //only allow groups to be selected if the account is discretionary
      $scope.showGroups = true;
      if (currentUser.securityMode !== 'Open') {
        //if the user is discretionary, they must select at least one group
        $scope.groupsRequired = true;
      }
    }
    init().then(
      function (response) {
        $scope.loading = false;
      },
      function (errorMsg) {
        $scope.loading = false;
        $scope.onLoadErrorText = errorMsg;
        $scope.onLoadErrorFlag = true;
      },
    );
  }

  $rootScope.$watch('currentUser', function (newVal, oldVal) {
    if (newVal && typeof oldVal === 'undefined') {
      currentUser = $rootScope.currentUser;

      if (currentUser.account.securityMode !== 'Open') {
        $scope.showGroups = true;
        if (currentUser.securityMode !== 'Open') {
          $scope.groupsRequired = true;
        }
      }
      init().then(
        function (response) {
          $scope.loading = false;
        },
        function (errorMsg) {
          $scope.loading = false;
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
        },
      );
    }
  });

  $scope.emailChanged = function () {
    window.dataLayer.push({
      event: 'newUserEmailChanged',
    });
  };
}
